import { http } from "@next-core/http";
let nativeController;
export function initAbortController() {
  if (!window.AbortController) {
    return;
  }
  nativeController = new AbortController();
  http.interceptors.request.use(config => {
    var _config$options;
    return {
      ...config,
      options: {
        // Allow user config to override the default abort signal
        signal: (_config$options = config.options) !== null && _config$options !== void 0 && _config$options.noAbortOnRouteChange ? null : nativeController.signal,
        ...config.options
      }
    };
  });
}
export function abortPendingRequest() {
  if (nativeController) {
    nativeController.abort();
    nativeController = new AbortController();
  }
}
//# sourceMappingURL=abortController.js.map